import { FormFieldKey } from 'src/app/@shared/form/form.types';

export const DYNAMIC_FORM_LIST_LABELS: Partial<Record<FormFieldKey, string>> = {
  contactPersons: 'FORM.LIST.TITLE.CONTACT_PERSONS',
  contactPersonsFreeText: 'FORM.LIST.TITLE.CONTACT_PERSONS',
  emails: 'FORM.LIST.TITLE.EMAILS',
  emailsExtended: 'FORM.LIST.TITLE.EMAILS',
  icd10Codes: 'FORM.LIST.TITLE.ICD10_CODES',
  icd11Codes: 'FORM.LIST.TITLE.ICD11_CODES',
  links: 'FORM.LIST.TITLE.LINKS',
  orphanetSynonyms: 'FORM.LIST.TITLE.ORPHANET_SYNONYMS',
  phoneContacts: 'FORM.LIST.TITLE.PHONE_NUMBERS',
  phoneNumbers: 'FORM.LIST.TITLE.PHONE_NUMBERS',
  socialMediaLinks: 'FORM.LIST.TITLE.SOCIAL_MEDIA_LINKS',
  synonyms: 'FORM.LIST.TITLE.SYNONYMS',
  topicsFreeText: 'FORM.LIST.TITLE.TOPICS',
  websites: 'FORM.LIST.TITLE.WEBSITES',
};
